import React, { useEffect, useState, useRef } from "react";
import styles from "../commanstyles.module.css";
import { getIndexopenCharges } from "../../../Services/APIrequests";
import { useParams } from "react-router-dom";
import { FaRupeeSign } from "react-icons/fa";
import {
    HiArrowsUpDown,
    HiOutlineArrowUp,
    HiOutlineArrowDown,
} from "react-icons/hi2";
import { formatIndianNumber } from "../../../Util/NumberConversion";

const IndexCharges = ({ refreshLoading }) => {
    const [openChargeData, setOpenChargeData] = useState([]);
    const [allChargeData, setAllChargeData] = useState([]); // Store all data for filtering
    const { cin } = useParams();
    const [currency, setCurrency] = useState("INR");

    const [sortField, setSortField] = useState(null);
    const [sortOrder, setSortOrder] = useState("asc");

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalCounts, setTotalCounts] = useState(0);
    const limit = 10;

    // Filter states
    const [showHolderFilter, setShowHolderFilter] = useState(false);
    const [selectedHolders, setSelectedHolders] = useState([]);
    const [availableHolders, setAvailableHolders] = useState([]);
    const filterRef = useRef(null);
    const [isLoadingAll, setIsLoadingAll] = useState(false);

    const formatNumber = (num) => {
        return num.toLocaleString();
    };

    // const convertValue = (value) => {
    //     switch (currency) {
    //         case "Lakh":
    //             return value / 100000;
    //         case "Million":
    //             return value / 1000000;
    //         case "INR":
    //             return value;
    //         case "Crore":
    //             return value / 10000000
    //         default:
    //             return value;
    //     }
    // };


    const convertValue = (value) => {
        const num = Number(value) || 0;
        switch (currency) {
            case "Lakh":
                return num / 100000;
            case "Million":
                return num / 1000000;
            case "Crore":
                return num / 10000000;
            case "INR":
            default:
                return num;
        }
    };

    const getIndicator = (field) => {
        if (sortField !== field) {
            return (
                <HiArrowsUpDown
                    style={{
                        marginLeft: "6px",
                        fontSize: "16px",
                        color: "#fff",
                        fontWeight: "600",
                    }}
                />
            );
        }
        return sortOrder === "asc" ? (
            <HiOutlineArrowUp
                style={{
                    marginLeft: "6px",
                    fontSize: "16px",
                    color: "#fff",
                    fontWeight: "600",
                }}
            />
        ) : (
            <HiOutlineArrowDown
                style={{
                    marginLeft: "6px",
                    fontSize: "16px",
                    color: "#fff",
                    fontWeight: "600",
                }}
            />
        );
    };

    const sortData = (field) => {
        const sortedData = [...openChargeData];
        const newSortOrder =
            sortField === field && sortOrder === "asc" ? "desc" : "asc";

        setSortField(field);
        setSortOrder(newSortOrder);

        sortedData.sort((a, b) => {
            if (field === "creationDate") {
                const dateA = new Date(a.filing_date).getTime();
                const dateB = new Date(b.filing_date).getTime();
                return newSortOrder === "asc" ? dateA - dateB : dateB - dateA;
            }

            if (field === "modificationDate") {
                const dateA = new Date(a.dateOfModification).getTime();
                const dateB = new Date(b.dateOfModification).getTime();
                return newSortOrder === "asc" ? dateA - dateB : dateB - dateA;
            }

            if (field === "holder") {
                const nameA = (a.charge_order_name || "").toLowerCase();
                const nameB = (b.charge_order_name || "").toLowerCase();
                return newSortOrder === "asc"
                    ? nameA.localeCompare(nameB)
                    : nameB.localeCompare(nameA);
            }

            if (field === "amount") {
                const amountA = convertValue(a.amount || 0);
                const amountB = convertValue(b.amount || 0);
                return newSortOrder === "asc"
                    ? amountA - amountB
                    : amountB - amountA;
            }

            return 0;
        });

        setOpenChargeData(sortedData);
    };

    useEffect(() => {
        async function fetchChargeData() {
            try {
                const response = await getIndexopenCharges(cin, currentPage, limit);
                if (response.data && response.data.openCharges) {
                    setOpenChargeData(response.data.openCharges);
                    
                    if (response.data.pagination) {
                        setCurrentPage(response.data.pagination.currentPage);
                        setTotalPages(response.data.pagination.totalPages);
                        setTotalCounts(response.data.pagination.totalCounts);
                    }
                } else if (
                    response.data?.message ===
                    "No open charges found for the given CIN"
                ) {
                    setOpenChargeData([]);
                    setTotalPages(1);
                    setTotalCounts(0);
                } else {
                    console.log("No charge details found in response");
                }
            } catch (error) {
                console.error("Failed to fetch charge data:", error);
                console.error(
                    error.response?.data?.message || "Something went wrong"
                );
            }
        }
        
        // Only fetch page by page when no filters are active
        if (refreshLoading == false && selectedHolders.length === 0) {
            fetchChargeData();
        }
    }, [cin, currentPage, refreshLoading, selectedHolders.length]);

    // Fetch all data when component mounts or CIN changes to populate filter options
    useEffect(() => {
        async function fetchAllChargeData() {
            if (isLoadingAll) return;
            
            try {
                setIsLoadingAll(true);
                const allData = [];
                let page = 1;
                let hasMore = true;

                while (hasMore) {
                    const response = await getIndexopenCharges(cin, page, limit);
                    if (response.data && response.data.openCharges) {
                        allData.push(...response.data.openCharges);
                        
                        if (response.data.pagination) {
                            hasMore = page < response.data.pagination.totalPages;
                            page++;
                        } else {
                            hasMore = false;
                        }
                    } else {
                        hasMore = false;
                    }
                }

                setAllChargeData(allData);
                
                // Extract unique holder names for filter
                const uniqueHolders = [...new Set(
                    allData
                        .map(charge => charge.charge_order_name)
                        .filter(name => name && name.trim() !== "")
                )].sort();
                setAvailableHolders(uniqueHolders);
                setIsLoadingAll(false);
            } catch (error) {
                console.error("Failed to fetch all charge data:", error);
                setIsLoadingAll(false);
            }
        }

        if (refreshLoading === false) {
            fetchAllChargeData();
        }
    }, [cin, refreshLoading]);

    useEffect(() => {
        if (typeof window !== "undefined") {
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    }, [currentPage]);

    // Close filter dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (filterRef.current && !filterRef.current.contains(event.target)) {
                setShowHolderFilter(false);
            }
        };

        if (showHolderFilter) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showHolderFilter]);

    // Filter data based on selected holders
    const getFilteredData = () => {
        // When filters are active, use allChargeData, otherwise use openChargeData
        const dataSource = selectedHolders.length > 0 ? allChargeData : openChargeData;
        
        if (selectedHolders.length === 0) {
            return dataSource;
        }
        
        return dataSource.filter(charge => 
            selectedHolders.includes(charge.charge_order_name)
        );
    };

    const filteredData = getFilteredData();
    
    // Client-side pagination for filtered data
    const getPaginatedData = () => {
        if (selectedHolders.length === 0) {
            // No filter applied, return server-paginated data
            return filteredData;
        }
        
        // Filter applied, do client-side pagination
        const startIndex = (currentPage - 1) * limit;
        const endIndex = startIndex + limit;
        return filteredData.slice(startIndex, endIndex);
    };
    
    const paginatedData = getPaginatedData();
    
    // Calculate total pages for filtered data
    const getDisplayTotalPages = () => {
        if (selectedHolders.length === 0) {
            return totalPages;
        }
        return Math.ceil(filteredData.length / limit);
    };
    
    const displayTotalPages = getDisplayTotalPages();
    
    // Get display total count
    const getDisplayTotalCount = () => {
        if (selectedHolders.length === 0) {
            return totalCounts;
        }
        return filteredData.length;
    };
    
    const displayTotalCount = getDisplayTotalCount();
    
    // Reset to page 1 when filters change
    useEffect(() => {
        setCurrentPage(1);
    }, [selectedHolders]);

    // Toggle holder selection
    const handleHolderToggle = (holder) => {
        setSelectedHolders(prev => {
            if (prev.includes(holder)) {
                return prev.filter(h => h !== holder);
            } else {
                return [...prev, holder];
            }
        });
    };

    return (
        <div className={styles.Indexcharge_container}>
            <div className={styles.headertext_con}>
                <h1 id={styles.headertext}>Active Charges</h1>
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        flexWrap: "wrap",
                    }}>
                    {/* Icon */}
                    <div
                        style={{
                            fontSize: "18px",
                            color: "var(--PrimaryColor)",
                        }}>
                        <FaRupeeSign />
                    </div>

                    {/* Dropdown */}
                    <div>
                        <select
                            value={currency}
                            onChange={(e) => setCurrency(e.target.value)}
                            style={{
                                padding: "6px 12px",
                                borderRadius: "6px",
                                border: "1px solid #ccc",
                                fontSize: "14px",
                                outline: "none",
                                cursor: "pointer",
                                minWidth: "120px",
                            }}>
                            <option value="Crore">Crore</option>
                            <option value="Lakh">Lakh</option>
                            <option value="INR">INR</option>
                            <option value="" disabled>
                                --------
                            </option>
                            <option value="Million">Million</option>
                        </select>
                    </div>

                    {/* Holder Filter */}
                    <div style={{ position: "relative" }} ref={filterRef}>
                        <button
                            onClick={() => setShowHolderFilter(!showHolderFilter)}
                            style={{
                                padding: "6px 12px",
                                borderRadius: "6px",
                                border: "1px solid #ccc",
                                fontSize: "14px",
                                outline: "none",
                                cursor: "pointer",
                                backgroundColor: selectedHolders.length > 0 ? "var(--PrimaryColor)" : "#fff",
                                color: selectedHolders.length > 0 ? "#fff" : "#333",
                                fontWeight: "500",
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                            }}>
                            Holder Filter {selectedHolders.length > 0 && `(${selectedHolders.length})`}
                            <span>▼</span>
                        </button>
                        
                        {showHolderFilter && (
                            <div style={{
                                position: "absolute",
                                top: "100%",
                                left: "0",
                                backgroundColor: "#fff",
                                border: "1px solid #ccc",
                                borderRadius: "6px",
                                padding: "10px",
                                minWidth: "300px",
                                maxHeight: "400px",
                                overflowY: "auto",
                                zIndex: 1000,
                                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                marginTop: "5px"
                            }}>
                                {availableHolders.length > 0 ? (
                                    <>
                                        {availableHolders.map((holder, idx) => (
                                            <div 
                                                key={idx}
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    padding: "8px",
                                                    cursor: "pointer",
                                                    color: "#333",
                                                    fontSize: "14px",
                                                    borderRadius: "4px",
                                                    transition: "background-color 0.2s",
                                                }}
                                                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#f0f0f0"}
                                                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}
                                                onClick={() => handleHolderToggle(holder)}>
                                                <input 
                                                    type="checkbox"
                                                    checked={selectedHolders.includes(holder)}
                                                    onChange={() => {}}
                                                    style={{
                                                        marginRight: "10px",
                                                        cursor: "pointer",
                                                        width: "16px",
                                                        height: "16px"
                                                    }}
                                                />
                                                <span style={{ flex: 1 }}>{holder}</span>
                                            </div>
                                        ))}
                                        <button
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setShowHolderFilter(false);
                                            }}
                                            style={{
                                                marginTop: "10px",
                                                padding: "6px 16px",
                                                backgroundColor: "#093A7F",
                                                color: "#fff",
                                                border: "none",
                                                borderRadius: "4px",
                                                cursor: "pointer",
                                                width: "100%",
                                                fontSize: "14px",
                                                fontWeight: "500"
                                            }}>
                                            Close
                                        </button>
                                    </>
                                ) : (
                                    <div style={{ padding: "8px", color: "#666", fontSize: "14px" }}>
                                        No holders available
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Selected Filter Tags */}
            {selectedHolders.length > 0 && (
                <div style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "8px",
                    marginTop: "15px",
                    marginBottom: "10px",
                    padding: "10px",
                    backgroundColor: "#f5f5f5",
                    borderRadius: "6px"
                }}>
                    <span style={{
                        fontSize: "14px",
                        fontWeight: "500",
                        color: "#666",
                        marginRight: "5px",
                        display: "flex",
                        alignItems: "center"
                    }}>Selected Holders:</span>
                    {selectedHolders.map((holder, idx) => (
                        <div
                            key={idx}
                            style={{
                                display: "inline-flex",
                                alignItems: "center",
                                backgroundColor: "var(--PrimaryColor)",
                                color: "#fff",
                                padding: "4px 10px",
                                borderRadius: "16px",
                                fontSize: "13px",
                                gap: "6px"
                            }}>
                            <span>{holder}</span>
                            <button
                                onClick={() => handleHolderToggle(holder)}
                                style={{
                                    background: "none",
                                    border: "none",
                                    color: "#fff",
                                    cursor: "pointer",
                                    fontSize: "16px",
                                    padding: "0",
                                    lineHeight: "1",
                                    fontWeight: "bold"
                                }}>
                                ×
                            </button>
                        </div>
                    ))}
                    <button
                        onClick={() => setSelectedHolders([])}
                        style={{
                            backgroundColor: "#ff5252",
                            color: "#fff",
                            border: "none",
                            padding: "4px 12px",
                            borderRadius: "16px",
                            fontSize: "13px",
                            cursor: "pointer",
                            fontWeight: "500"
                        }}>
                        Clear All
                    </button>
                </div>
            )}

            <div className={styles.table_subcontainer}>
                <table className={styles.commantable}>
                    <thead className={styles.table_header}>
                        <tr className={styles.tableHeaderRow}>
                            <th className={styles.tableHeader}>Sr. No</th>
                            <th className={styles.tableHeader}>Charge Id</th>

                            <th
                                className={styles.tableHeader}
                                onClick={() => sortData("holder")}
                                style={{ cursor: "pointer" }}>
                                Charge Holder Name{" "}
                                <span
                                    style={{
                                        marginLeft: "6px",
                                        fontSize: "12px",
                                    }}>
                                    {getIndicator("holder")}
                                </span>
                            </th>

                            <th
                                className={styles.tableHeader}
                                onClick={() => sortData("creationDate")}
                                style={{ cursor: "pointer" }}>
                                Date of Creation{" "}
                                <span
                                    style={{
                                        marginLeft: "6px",
                                        fontSize: "12px",
                                    }}>
                                    {getIndicator("creationDate")}
                                </span>
                            </th>

                            <th
                                className={styles.tableHeader}
                                onClick={() => sortData("modificationDate")}
                                style={{ cursor: "pointer" }}>
                                Date of Modification{" "}
                                <span
                                    style={{
                                        marginLeft: "6px",
                                        fontSize: "12px",
                                    }}>
                                    {getIndicator("modificationDate")}
                                </span>
                            </th>

                            <th
                                className={styles.tableHeader}
                                onClick={() => sortData("amount")}
                                style={{ cursor: "pointer" }}>
                                Amount{" "}
                                <span
                                    style={{
                                        marginLeft: "6px",
                                        fontSize: "12px",
                                    }}>
                                    {getIndicator("amount")}
                                </span>
                            </th>

                            <th className={styles.tableHeader}>
                                Charge Holder Address
                            </th>
                            <th className={styles.tableHeader}>
                                Whether charge registered by other entity
                            </th>
                            <th className={styles.tableHeader}>
                                Asset Holder Name
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        {paginatedData.length > 0 ? (
                            paginatedData.map((charge, index) => (
                                <tr key={charge.id} className={styles.tableRow}>
                                    <td className={styles.tableCell}>
                                        {(currentPage - 1) * limit + index + 1}
                                    </td>
                                    <td className={styles.tableCell}>
                                        {charge.charge_id}
                                    </td>
                                    <td className={styles.tableCell}>
                                        {charge.charge_order_name || "-"}
                                    </td>

                                    <td className={styles.tableCell}>
                                        {charge.date &&
                                            !isNaN(new Date(charge.date).getTime())
                                            ? new Date(
                                                charge.date
                                            ).toLocaleDateString("en-GB", {
                                                day: "numeric",
                                                month: "short",
                                                year: "numeric",
                                            })
                                            : "-"}
                                    </td>

                                    <td className={styles.tableCell}>
                                        {charge.dateOfModification &&
                                            charge.status == "Modification" &&
                                            !isNaN(new Date(charge.dateOfModification).getTime())
                                            ? new Date(
                                                charge.dateOfModification
                                            ).toLocaleDateString("en-GB", {
                                                day: "numeric",
                                                month: "short",
                                                year: "numeric",
                                            })
                                            : "-"}
                                    </td>

                                    <td className={styles.tableCell}>
                                        {formatIndianNumber(
                                            convertValue(charge.amount)
                                        )}
                                        {/* {charge.amount} */}
                                    </td>
                                    <td className={styles.tableCell}>
                                        {charge.chargeHolderAddress || "-"}
                                    </td>
                                    <td className={styles.tableCell}>
                                        {charge?.whetherCharge == 1
                                            ? "Yes"
                                            : "No"}
                                    </td>
                                    <td className={styles.tableCell}>
                                        {charge.assetHolderName || "-"}
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td style={{textAlign:"center"}} colSpan="9" className={styles.noDataRow}>
                                    No open charges found for the given CIN
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {openChargeData.length > 0 && displayTotalPages > 1 && (
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '10px',
                    marginTop: '20px',
                    padding: '10px'
                }}>
                    <button
                        onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                        disabled={currentPage === 1}
                        style={{
                            padding: '8px 16px',
                            borderRadius: '6px',
                            border: '1px solid #ccc',
                            backgroundColor: currentPage === 1 ? '#f0f0f0' : 'var(--PrimaryColor)',
                            color: currentPage === 1 ? '#999' : '#fff',
                            cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                            fontSize: '14px',
                            fontWeight: '500'
                        }}>
                        Previous
                    </button>
                    
                    <span style={{
                        fontSize: '14px',
                        color: '#333',
                        fontWeight: '500'
                    }}>
                        Page {currentPage} of {displayTotalPages} ({displayTotalCount} total)
                    </span>
                    
                    <button
                        onClick={() => setCurrentPage(prev => Math.min(prev + 1, displayTotalPages))}
                        disabled={currentPage === displayTotalPages}
                        style={{
                            padding: '8px 16px',
                            borderRadius: '6px',
                            border: '1px solid #ccc',
                            backgroundColor: currentPage === displayTotalPages ? '#f0f0f0' : 'var(--PrimaryColor)',
                            color: currentPage === displayTotalPages ? '#999' : '#fff',
                            cursor: currentPage === displayTotalPages ? 'not-allowed' : 'pointer',
                            fontSize: '14px',
                            fontWeight: '500'
                        }}>
                        Next
                    </button>
                </div>
            )}
        </div>
    );
};

export default IndexCharges;
